<template lang="pug">
  #admin-super-programs
    .mb-5
      .level.is-mobile
        .level-left
          .level-item
            WtTitle(h1) Programs
        .level-right
          .level-item
            WtButton(
              @click.native="$router.push({ name: 'CreateBeWellProgram' })"
            )
              | Create Program

    ProgramReportsAdminSuper
</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import ProgramReportsAdminSuper from "@@/StatsReportingAdminSuper/ProgramReportsAdminSuper";

export default {
  name: "AdminSuperPrograms",

  components: {
    WtButton,
    WtTitle,
    ProgramReportsAdminSuper
  }
};
</script>

<style lang="sass" scoped>
#admin-super-programs
  padding: 2rem
</style>
